/**
 * 🔬 TIER 9 BUILDINGS - Science & Research
 * 
 * Unlocked by: Astronomy, Scientific Method, Advanced Research
 * Cost multiplier: 1526x | Prod multiplier: 43x
 * Costs: 100,000-300,000 | Production: 20-40/s
 * Target ROI: ~25 minutes
 */

export const TIER_09_BUILDINGS = {
  observatory: {
    id: 'observatory',
    name: 'Observatory',
    icon: '🔭',
    tier: 9,
    description: 'Studies the stars',
    flavor: 'Mapping the heavens above.',
    baseCost: { stone: 120000, gold: 72000, steel: 36000 },
    baseProduction: { science: 21.5 },
    unlockCondition: { tech: 'astronomy' },
  },

  laboratory: {
    id: 'laboratory',
    name: 'Laboratory',
    icon: '🔬',
    tier: 9,
    description: 'Conducts experiments',
    flavor: 'Where hypotheses become discoveries.',
    baseCost: { stone: 144000, steel: 48000, tools: 24000 },
    baseProduction: { science: 34.5 },
    unlockCondition: { tech: 'scientific_method' },
  },

  researchCenter: {
    id: 'researchCenter',
    name: 'Research Center',
    icon: '🧪',
    tier: 9,
    description: 'Advanced scientific research',
    flavor: 'Pushing the boundaries of knowledge.',
    baseCost: { steel: 96000, tools: 48000, energy: 24000 },
    baseProduction: { science: 43.0 },
    unlockCondition: { tech: 'advanced_research' },
  },
};

export default TIER_09_BUILDINGS;
